import { useDataValue } from 'Simple/Data.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'

export function useOnClick(props) {
  let letters = useDataValue({
    viewPath: props.viewPath,
    context: 'modal',
    path: 'letters',
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onClick() {
    if (letters.some(letter => !letter.task_id && !letter.document_node_id)) {
      setFlowTo(
        normalizePath(props.viewPath, '../../LeaveConfirmModal/Content')
      )
      return
    }

    if (typeof props?.onClose === 'function') {
      props.onClose()
    }
  }
}
